import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { Link, Spacer, useTheme, View } from 'vcc-ui';

const JSONTreeCore = dynamic(() =>
  import('react-json-tree').then((mod) => mod.JSONTree)
);
const getItemString = (type, data, itemType, itemString, keyPath) => {
  return (
    <span>{keyPath[0] === 'window.dataLayer' ? `(${data.length})` : ''}</span>
  );
};
const JSONTreeTheme = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED',
};
export const JSONTree = ({ data }) => {
  const theme = useTheme();
  const isDark = theme.name === 'volvo-dark';
  return (
    <JSONTreeCore
      theme={JSONTreeTheme}
      getItemString={getItemString}
      keyPath={['window.dataLayer']}
      data={data}
      invertTheme={!isDark}
      shouldExpandNode={() => true}
    />
  );
};

const createDataLayer = () => {
  var handler = {
    get: (target, property) => {
      return target[property];
    },
    set: (target, property, value) => {
      target[property] = value;
      if (property === 'length') {
        window.dataLayerListeners.forEach((setRefresh) => {
          setRefresh((refresh) => !refresh);
        });
      }
      return true;
    },
  };
  window.dataLayer = new Proxy([], handler);
  window.dataLayerListeners.forEach((setRefresh) => {
    setRefresh((refresh) => !refresh);
  });
};
if (typeof window !== 'undefined') {
  window.dataLayerListeners = [];
  createDataLayer();
}
const DataLayerViewer = () => {
  const [isBrowser, setIsBrowser] = useState(false);
  const [, setRefresh] = useState(false);
  useEffect(() => {
    window.dataLayerListeners.push(setRefresh);
    setIsBrowser(true);
  }, []);
  if (!isBrowser) return null;
  return (
    <View extend={{ overflowY: 'auto', height: 300 }}>
      <Spacer />
      {!!window.dataLayer.length && (
        <Link onClick={() => createDataLayer()}>Clear</Link>
      )}
      <Spacer />
      <JSONTree data={JSON.parse(JSON.stringify(window.dataLayer)).reverse()} />
    </View>
  );
};
export default DataLayerViewer;
